var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        ref: "openModal",
        attrs: { href: "#langCurrCountrySwitchModal", "data-toggle": "modal" },
      },
      [
        _c(
          "button",
          { staticClass: "btn btn-block", staticStyle: { color: "white" } },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.currentCurrencySymbol) +
                " | " +
                _vm._s(_vm.selectedLanguage.toUpperCase()) +
                "\n    "
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }